<template>
  <div class="flex h-12 w-full items-center justify-between pl-6">
    <div class="flex items-center gap-2">
      <!-- Warning Icon -->
      <i class="icon-[lucide--triangle-alert] text-warning-background" />
      <!-- Title -->
      <p class="text-base font-bold">
        {{ $t('manager.conflicts.title') }}
      </p>
    </div>
  </div>
</template>
